import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'accordion-group',
  template: `
  <div class="mypanel">
    <div class="title" (click)="toggle.emit()">
      {{title}}
    </div>
    <div class="body" [class.hidden]="!opened">
      <ng-content></ng-content>
    </div>
  <div>
  `,
  styleUrls: ['accordion.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AccordionGroupComponent {
  
  @Input() opened = false;
  @Input() title: string | undefined;

  /**
   * Emitted when user clicks on group titlebar
   * @type {EventEmitter<any>}
   */
  @Output() toggle: EventEmitter<any> = new EventEmitter<any>();
}
